if (!customElements.get('clear-input')) {
  class ClearInput extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.button = this.querySelector('button');
      this.input = this.querySelector('input');

      if (this.button && this.input) {
        this.button.addEventListener('click', () => {
          this.input.value = '';
          const predictiveSearch = this.closest('predictive-search');
          const searchResults = predictiveSearch?.querySelector(
            'predictive-search-results',
          );
          if (searchResults) {
            searchResults.innerHTML = '';
          }
          this.input.focus();
        });
      }
    }
  }

  customElements.define('clear-input', ClearInput);
}
